import MemberVoteModel from './member_vote_model';
export default Backbone.Collection.extend({
  model: MemberVoteModel
});